<script>
import {mapState} from "vuex";
import {TheMask} from "vue-the-mask";
import {EF_TRACKING_URL} from "@/paths/constants";
import axios from 'axios'

export default {
  components: {TheMask},
  props: {
    prepare: {
      type: Boolean,
      default: false,
    },
    customProps: {
      type: Object,
      default: () => ({}),
    }
  },

  data() {
    return {
      loading: null,
      zipCode: "",
      stateCode: "",
      zipCodeError: false,
      zipCodeEmptyError: false,
      zipCodeInvalidError: false,
      validRemote: false,
      readyShowPipesPopUp: false,
      showPipesPopUp: false,
      pipesFirstName: '',
      pipesLastName: '',
      pipesPhoneNumber: '',
      pipesFirstNameError: false,
      pipesLastNameError: false,
      pipesPhoneNumberError: false,
      pipesValidationLoading: false,
      pipesValidationComplete: false,
      showPipesCompletionMessage: false
    };
  },

  computed: {
    ...mapState([
      "fieldsFromUrl",
      "fieldsFromStorage",
      "fields",
      'highRisk',
      'transactionIdIsNotReady',
    ]),

    isNotValid() {
      return this.zipCodeError || this.zipCodeInvalidError || !this.validRemote
    },

    leaveBehindUrl() {
      if (this.isNotValid || this.transactionIdIsNotReady) {
        return 'javascript:;'
      }

      const searchParams = new URLSearchParams(location.search)
      searchParams.set('zip_code', this.zipCode)
      searchParams.set('slb', '1')

      if (this.fields.transaction_id) {
        searchParams.set('_ef_transaction_id', this.fields.transaction_id)
      }

      return location.pathname + '?' + searchParams.toString()
    }
  },

  created() {
    if (this.prepare) {

      if (this.fieldsFromUrl["zip_code"] && this.fieldsFromUrl['slb']) {
        this.zipCode = this.fieldsFromUrl["zip_code"];
        this.setAnswer(true)
        return
      }

      if (this.fieldsFromStorage["zip_code"] && this.fieldsFromUrl['slb']) {
        this.zipCode = this.fieldsFromStorage["zip_code"];
        this.setAnswer(true)
        return
      }

      this.$emit('show-this-step')
    } else {
      if (this.fieldsFromUrl['ver'] === 'pop') {
        this.readyShowPipesPopUp = true
      }

      if (this.fieldsFromStorage["zip_code"]) {
        this.zipCode = this.fieldsFromStorage["zip_code"];
      }
      if (this.fieldsFromUrl["zip_code"]) {
        this.zipCode = this.fieldsFromUrl["zip_code"];
      }

      if (this.zipCode) {
        this.validate()
      }
    }

  },

  methods: {
    async setAnswer(answer) {
      const valid = await this.validate();
      if (!valid) return;
      this.loading = null;
      this.loading = answer;
      this.$store.dispatch("setAnswers", [
        {
          field: "zip_code",
          value: this.zipCode,
        },
      ]);
      this.$emit("next-step");

      if (answer === 'Continue') {
        location.href = `https://click.clktraker.com/aff_ad?campaign_id=8157&aff_id=10257&hostNameId=2951&aff_sub=AFHpop&aff_click_id=${this.fieldsFromUrl['_ef_transaction_id']}&aff_sub2=${this.fieldsFromUrl['affid'] || '1'}&aff_sub3=${this.fieldsFromUrl['sub_id'] || ''}`
      }
    },

    async validate() {
      if (this.zipCode.length === 0) {
        this.zipCodeError = true;
        this.zipCodeEmptyError = true;
        return false;
      }

      if (this.zipCode.length < 5) {
        this.zipCodeError = true;
        this.zipCodeInvalidError = true;
        return false;
      }

      this.validRemote = await this.zippopotamValidation();
      if (!this.validRemote) return false

      return true
    },

    async zippopotamValidation() {
      this.loading = 'Continue'
      const zipReqURL = "//api.zippopotam.us/us/";
      let response = {}
      try {
        response = await this.axios.get(`${zipReqURL}${this.zipCode}`)
      } catch (e) {
        this.zipCodeError = true;
        this.zipCodeInvalidError = true;
      }

      this.loading = ''
      if (response.status === 200 && !this.zipCodeError) return true
    },

    async progressionTracking() {
      const eventID = this.customProps.trackProgress ? "34" : "51"
      await this.axios.post(`${EF_TRACKING_URL}&event_id=${eventID}&transaction_id=${this.fields['transaction_id']}`)
    },

    showPipesPopUpModal() {
      if (!this.readyShowPipesPopUp) return
      this.showPipesPopUp = true
    },

    closeModal() {
      this.showPipesPopUp = false
      this.readyShowPipesPopUp = false
    },

    validatePipesNames() {
      this.pipesFirstNameError = this.pipesFirstName.length < 3
      this.pipesLastNameError = this.pipesLastName.length < 3
    },

    async validatePipesPhone() {
      this.pipesPhoneNumberError = this.pipesPhoneNumber.length < 10
      if (this.pipesPhoneNumberError) return

      await this.ipqsPhoneValidation()
    },

    async ipqsPhoneValidation() {
      const url = 'https://validations.org31415.dev/api/validations/ipqs/phone'
      const phone = this.pipesPhoneNumber.replace(/[()\-\s]+/g, "")

      const response = await this.axios.post(url, {
        phone
      })

      const { data } = response
      if (!data['valid'] || !data['active']) {
        this.pipesPhoneNumberError = true
      } else if (data['fraud_score'] > 85) {
        this.pipesPhoneNumberError = true
      }
    },

    async validatePipesModal() {
      this.pipesValidationLoading = true
      this.validatePipesNames()
      await this.validatePipesPhone()

      if (this.pipesFirstNameError || this.pipesLastNameError || this.pipesPhoneNumberError) {
        this.pipesValidationLoading = false
        return
      }

      const data = {
        lp_campaign_id: 7981,
        lp_supplier_id: 16326,
        lp_key: "nr2aj5judnw2",
        first_name: this.pipesFirstName,
        last_name: this.pipesLastName,
        phone: this.pipesPhoneNumber,
        trusted_form_cert_url: this.getTrustedForm(),
        user_agent: this.fields.user_agent,
        ip_address: this.fields.ip_address,
        sub_id1: this.fields.sub1 || ''
      }

      await axios
        .post('https://api.leadprosper.io/ingest', data)
        .then(() => {
          this.pipesValidationLoading = false
          this.pipesValidationComplete = true
        })
    },

    getTrustedForm() {
      let tfCertUrl = document.getElementById("xxCertUrl_0").value;
      tfCertUrl.split("https://cert.trustedform.com/")
      return tfCertUrl
    }
,

    handleChange() {
      this.zipCodeError = false;
      this.zipCodeInvalidError = false;
      this.zipCodeEmptyError = false;
      this.validate()
    },
  },
};
</script>

<template>
  <div v-if="!prepare">
    <div class="pipes-popup-modal" :class="{'open' : showPipesPopUp}">
      <div class="modal-content">
        <span
          class="close-modal"
          @click="closeModal"
        >
          &times;
        </span>
        <div class="top-modal">
          <h2 v-if="!pipesValidationComplete">Want us to call you now?</h2>
          <div
            class="pipes-validation-complete"
            v-if="pipesValidationComplete"
          >
            <h2>Thanks! You'll receive a call within 5 minutes.</h2>
            <p>In the meantime, complete the form!</p>
            <button @click="closeModal">Okay</button>
          </div>
        </div>
        <div
          class="inner-modal-content"
          v-if="!pipesValidationComplete">
          <input
            type="text"
            placeholder="First Name"
            :class="{'error' : pipesFirstNameError}"
            v-model="pipesFirstName"
            @input="pipesFirstNameError = false"
          />
          <input
            type="text"
            placeholder="Last Name"
            :class="{'error' : pipesLastNameError}"
            v-model="pipesLastName"
            @input="pipesLastNameError = false"
          />
          <the-mask
            v-model="pipesPhoneNumber"
            :class="{'error' : pipesPhoneNumberError}"
            :mask="['(###) ###-####']"
            placeholder="Phone Number"
            @input="pipesPhoneNumberError = false"
          />
          <button @click="validatePipesModal">
            <span v-show="!pipesValidationLoading">Submit</span>
            <img
              class="spinner"
              :class="{'loading' : pipesValidationLoading}"
              src="../../assets/img/spinner.gif"
              alt=""
            >
          </button>

          <p style="font-size: 12pt">
            By clicking "Submit", I agree to the Terms of Service and Privacy Policy,
            which includes a mandatory arbitration provision, and
            provide my express written consent via electronic signature authorizing
            AmericanFirstHealth.com and one or more insurance companies, their agents and
            marketing partners to contact me about Insurance to the number I provided
            above (including any wireless number). I agree to receive emails,
            telemarketing calls, text messages, and pre-recorded messages via an
            autodialed phone system, even if my telephone number is a mobile number that
            is currently listed on any state, federal or corporate “Do Not Call” list. I
            understand that my consent is not a condition of purchase of any goods or
            services and that standard message and data rates may apply.
          </p>
        </div>
      </div>
    </div>

    <div class="container is-max-widescreen px-5">
      <div class="has-text-centered item-box">
        <h2 class="question mb-3">Please enter your zip code.</h2>
        <form
          class="container is-max-widescreen"
          @submit.prevent=""
          @mouseover="showPipesPopUpModal"
        >
          <b-field
            :message="[
              { 'Please enter a valid zip.': zipCodeInvalidError },
              { 'Please enter a zip code.': zipCodeEmptyError },
            ]"
            :type="zipCodeError ? 'is-danger' : ''"
            class="has-text-left"
          >
            <the-mask
              v-model.trim="zipCode"
              :class="{ 'is-danger': zipCodeError }"
              :mask="['#####']"
              class="input mt-2"
              placeholder="Zip code"
              @input="handleChange"
            />
          </b-field>
          <a :href="leaveBehindUrl" target="_blank">
            <input
              :disabled="isNotValid"
              :value="transactionIdIsNotReady || loading === 'Continue' ? 'Please wait...': 'Continue'"
              class="submitButton mt-3"
              type="button"
              @click="setAnswer('Continue')"
            />
          </a>
        </form>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.pipes-popup-modal {
  display: none;
  padding: 20px;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);

  &.open {
    display: block;
  }

  .modal-content {
    background-color: #fefefe;
    margin: 80px auto 20px;
    padding: 20px;
    width: 100%;
    max-width: 425px;
    border-radius: 8px;
    box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1);
    max-height: calc(100vh - 120px);

    .close-modal {
      position: absolute;
      top: -5px;
      right: 10px;
      color: #aaa;
      font-size: 28px;
      font-weight: bold;

      &:hover, :focus {
        color: black;
        text-decoration: none;
        cursor: pointer;
      }
    }

    .top-modal {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      max-width: 320px;
      width: 100%;
      margin: 0 auto;
      gap: 5px;

      h2 {
        font-size: 1.625rem;
        color: #333333;
        font-weight: 500;
        text-align: center;
      }

      .pipes-validation-complete {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;

        h2 {
          font-weight: bold;
        }

        p {
          font-size: 18px;
        }
      }
    }

    .inner-modal-content {
      margin-top: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      gap: 20px;

      input {
        max-width: 320px;
        width: 100%;
        height: 38px;
        letter-spacing: .025em;
        border-radius: 4px;
        padding-left: 10px;
        background-color: #fff;
        border: #dbdbdb 1px solid;
        color: #363636;
        box-shadow: inset 0 0.0625em 0.125em rgb(10 10 10 / 5%);
        font-size: 16px;

        &.error {
          border: 1px solid red;
        }
      }

      p {
        max-width: 320px;
        width: 100%;
        font-size: 14px;
        color: #787878;
        text-align: justify;
      }
    }
  }
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 12px;
    max-width: 320px;
    background-color: #e22866;
    color: #fff;
    border-radius: 5px;
    border: 0;
    transition: all 0.2s cubic-bezier(0.39, 0.575, 0.565, 1);
    padding-left: 10px;
    font-size: 22px;
    height: 38px;

    &:focus {
      outline: none;
    }

    .spinner {
      display: none;
      height: 45px;
      width: 45px;
      filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(37deg) brightness(103%) contrast(101%);

      &.loading {
        display: block;
      }
    }

    &:hover {
      cursor: pointer;
      box-shadow: 0 0 0 5px rgb(0 0 0 / 10%);
      background: #c51b54;
    }
  }
}

@media screen and (max-width: 525px) {
  .pipes-popup-modal .modal-content {
    margin: 70px auto 20px;
  }
}
</style>
